import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import OcrScanner from "@/components/OcrScanner";

export const VehicleEditDialog = ({ open, onOpenChange, vehicle, onUpdated }) => {
  const [form, setForm] = useState({
    license_plate: "", brand: "", model: "", year: "", vin: "", mileage: ""
  });

  useEffect(() => {
    if (open && vehicle) {
      setForm({
        license_plate: vehicle.license_plate || "",
        brand: vehicle.brand || "",
        model: vehicle.model || "",
        year: vehicle.year?.toString() || "",
        vin: vehicle.vin || "",
        mileage: vehicle.mileage?.toString() || ""
      });
    }
  }, [open, vehicle]);

  const handleSubmit = async () => {
    if (!vehicle?.id) return;
    try {
      const payload = {
        ...form,
        year: parseInt(form.year) || 0,
        mileage: parseInt(form.mileage) || 0
      };
      await api.put(`/api/vehicles/${vehicle.id}`, payload);
      onUpdated?.({ ...vehicle, ...payload });
      onOpenChange(false);
      toast.success("Fahrzeugdaten aktualisiert");
    } catch {
      toast.error("Fehler beim Aktualisieren");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="detail-vehicle-edit-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Barlow Condensed' }}>Fahrzeugdaten bearbeiten</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Kennzeichen</Label>
            <div className="flex gap-2">
              <Input value={form.license_plate} onChange={(e) => setForm({ ...form, license_plate: e.target.value })} placeholder="B-AB 1234" className="flex-1" />
              <OcrScanner ocrType="license_plate" onResult={(text) => setForm({ ...form, license_plate: text })} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Marke</Label>
              <Input value={form.brand} onChange={(e) => setForm({ ...form, brand: e.target.value })} placeholder="VW" />
            </div>
            <div className="space-y-2">
              <Label>Modell</Label>
              <Input value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} placeholder="Golf" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Baujahr</Label>
              <Input type="number" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} placeholder="2020" />
            </div>
            <div className="space-y-2">
              <Label>Kilometerstand</Label>
              <div className="flex gap-2">
                <Input type="number" value={form.mileage} onChange={(e) => setForm({ ...form, mileage: e.target.value })} placeholder="50000" className="flex-1" />
                <OcrScanner ocrType="mileage" onResult={(text) => setForm({ ...form, mileage: text.replace(/\D/g, '') })} />
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Label>VIN (Fahrgestellnummer)</Label>
            <div className="flex gap-2">
              <Input value={form.vin} onChange={(e) => setForm({ ...form, vin: e.target.value })} placeholder="WVWZZZ3CZWE123456" className="flex-1" />
              <OcrScanner ocrType="vin" onResult={(text) => setForm({ ...form, vin: text })} />
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button onClick={handleSubmit} data-testid="detail-vehicle-save-btn">Speichern</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
